import { RepositoryFactory } from '../../repositoryFactory';
import BillingAddressRepository from '../../repositories/BillingAddressRepository';
import ShippingAddressRepository from '../../repositories/ShippingAddressRepository';

const AccountRepository = RepositoryFactory.get('account');

export default {
  state: {},
  mutations: {
    change_password_request(state) {
      state.status = 'loading';
    },
    change_password_success(state) {
      state.status = 'success';
    },
    change_password_error(state) {
      state.status = 'error';
    },
  },
  actions: {
    get({ commit }, payload) {
      return new Promise((resolve, reject) => {
        AccountRepository.get(payload).then((resp) => resp.data).then((resp) => {
          commit('auth/auth_update', { user: resp.data }, { root: true });
          resolve(resp);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    update_profile({ commit }, payload) {
      return new Promise((resolve, reject) => {
        AccountRepository.update_profile(payload).then((resp) => resp.data).then((resp) => {
          commit('auth/auth_update', { user: resp.data }, { root: true });
          resolve(resp);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    delete_billing_address({ commit }, payload) {
      return new Promise((resolve, reject) => {
        BillingAddressRepository.delete(payload).then((resp) => {
          console.log(commit);
          resolve(resp);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    delete_shipping_address({ commit }, payload) {
      return new Promise((resolve, reject) => {
        ShippingAddressRepository.delete(payload).then((resp) => {
          console.log(commit);
          resolve(resp);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    change_password({ commit }, payload) {
      commit('change_password_request');
      return new Promise((resolve, reject) => {
        AccountRepository.change_password(payload).then((resp) => {
          commit('change_password_success');
          resolve(resp);
        }).catch((err) => {
          commit('change_password_error');
          reject(err);
        });
      });
    },
  },
};
